import { css } from 'emotion';
import getFontStyles from '../../../../../lib/styles/getFontStyles';
import { LINE_HEIGHT } from '../../../../../lib/styles/dynamicStyleConstants';

function getStyles({ colors, fonts }) {
  const fontStyles = getFontStyles(fonts.contentDescriptionFont, {
    lineHeight: LINE_HEIGHT.EPISODE_PAGE_TEXT,
  });
  return {
    keywords: css({
      color: colors.contentDescriptionColor,
      ...fontStyles,
      fontSize: 16,
    }),
    keywordsKeyword: css({
      '&:hover, &:active': {
        color: colors.linkColor,
      },
    }),
  };
}

export default getStyles;
